(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-custom-js"] && !Shopify.designMode) return;
  try {
    window.initializeSwatches = function(colorMap = {}) {
    const selects = document.querySelectorAll(".single-option-selector");

    selects.forEach(select => {
      select.style.display = "none"; // hide original select box

      const selectedValue = select.value;

      // Get label before the select
      const label = select.getAttribute('data-option-name');
      const labelText = label?.trim().toLowerCase();

      // Check if this is a color swatch
      const isColorOption = labelText?.includes("color");

      const swatchContainer = document.createElement("div");
      swatchContainer.className = "swatch-container";

      Array.from(select.options).forEach(option => {
        const value = option.value;
        const swatch = document.createElement("div");
        swatch.title = value;

        if (isColorOption ) {
          swatch.className = "color-swatch";
          if(colorMap[value]){
            swatch.style.backgroundColor = colorMap[value];
          }else{
            swatch.style.backgroundColor = colorMap[value];
            swatch.setAttribute("style", `background-color: ${value?.trim().toLowerCase()}`);
          }
        } else {
          swatch.className = "text-swatch";
          swatch.textContent = value;
        }
    


        if (value === selectedValue) {
          swatch.classList.add("selected");
        }

        swatch.addEventListener("click", () => {
          swatchContainer.querySelectorAll(".color-swatch, .text-swatch")
            .forEach(el => el.classList.remove("selected"));

          swatch.classList.add("selected");

          select.value = value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });

        swatchContainer.appendChild(swatch);
      });

      if (select.nextElementSibling?.classList.contains('swatch-container')) {
        return; // skip if swatches already exist
      }
      // Insert swatches after the select
      select.parentNode.insertBefore(swatchContainer, select.nextSibling);
    });

    // Handle additional swatches like 'handed-option' radios
    const handedSwatches = document.querySelectorAll(".handed-option .swatch-container");
    handedSwatches.forEach(container => {
      container.querySelectorAll(".text-swatch").forEach(swatch => {
        swatch.addEventListener("click", () => {
          container.querySelectorAll(".text-swatch").forEach(s => s.classList.remove("selected"));
          swatch.classList.add("selected");

          const input = swatch.querySelector("input[type='radio']");
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
